import React from 'react';
import secondStepConstants from '../common/Constants';
import { Button} from 'react-bootstrap';
import secondStepConstanst from '../assets/items.json'


class SecondStep extends React.Component {
  constructor(props) {
    super(props);

    // Setup save/read top component state.
    this.saveTopState = props.saveTopState;
    this.readTopState = props.readTopState;

    let savedFirstState = this.readTopState('firstStepState');

    // Reading state parameters from top state.
    let savedStateFromTop = this.readTopState('secondStepState');

    this.state = {
       firstStepState: savedFirstState.movingFromAddress ? savedFirstState : {
        "movingFromAddress":{"value":{"lat":28.8240644,"lng":-81.3185346},"label":"Manhattan, New York, NY, USA","isValid":true,"cityAndState":{"city":"New York","state":"NY"}},"movingToAddress":{"value":{"lat":31.05679419999999,"lng":-89.18937199999999},"label":"Brooklyn, MS 39425, USA","isValid":true,"cityAndState":{"city":"Brooklyn","state":"MS"}},"movingFromFlights":{"value":"2","label":"2nd floor walk up"},"movingToFlights":{"value":"0","label":"Ground floor"},"moveSize":{"value":"1","label":"Studio or Partial Apartment"},"movingDate":"2018-11-24","errorclass":"before-error-validation","distance":9,"isValid":false
      },
      items: savedStateFromTop['items'] || {},
      totalVolume: savedStateFromTop['totalVolume'] || 0,
      addItemPrice: savedStateFromTop['addItemPrice'] || 0,
      customItems: savedStateFromTop['customItems'] || {},
      customItemIndex: savedStateFromTop['customItemIndex'] || 0,
      packingOption: savedStateFromTop['packingOption'] || {},
      tempuraPedic: savedStateFromTop['tempuraPedic'] || {checked: false, value:"No", qty: 0},
      walkUp: savedStateFromTop['walkUp'] || {checked: false, value:"No", qty: 0},
      rentBoxes: savedStateFromTop['rentBoxes'] || {checked: false, qty: 0},
      referrence: savedStateFromTop['referrence'] || {},
      packingHouseSize: savedStateFromTop['packingHouseSize'] || {},
      storageOption: savedStateFromTop['storageOption'] || { checked: false, qty : 0},
      tempuraPedicPrice: savedStateFromTop['tempuraPedicPrice'] || 0,
      rentBoxesPrice: savedStateFromTop['rentBoxesPrice'] || 0,
      volumeErrorMsg: 'hide-error-msg',
      customItemsErrorMsg: 'hide-error-msg'
    };

    // Binding all methods
    this.onQuantityChange= this.onQuantityChange.bind(this);
    this.onItemPlus= this.onItemPlus.bind(this);
    this.onItemMinus= this.onItemMinus.bind(this);
    this.calculateTotalVolume = this.calculateTotalVolume.bind(this);
    this.addCustomItem = this.addCustomItem.bind(this);
    this.removeCustomItem = this.removeCustomItem.bind(this);
    this.onInputFieldChange = this.onInputFieldChange.bind(this);
    this.onCustomItemFieldChange = this.onCustomItemFieldChange.bind(this);
    this.handleNext = this.handleNext.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.handleToggle = this.handleToggle.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.addRentBoxes = this.addRentBoxes.bind(this);
  }
  componentDidMount() {

    /**FRONT END BETWEEN STEPS STYLE**/
    if (document.getElementById("second-step-change")){
      document.querySelector(".second-step-expand").classList.add("second-step-expandthis");
      if(document.querySelector(".second-step-hide")){
        document.querySelector(".second-step-hide").classList.add("second-step-hidethis");
      }

       if (document.querySelector(".home_top")){
      document.querySelector(".home_top").classList.add("second-step-change-bg-pad");
    }
    }

    let firstStepState = this.state.firstStepState;

    let userInput = {
      'wardrobeNumber': 0,
      'binsNumber': 0,
      'cityStateFrom': firstStepState['movingFromAddress']['cityAndState'],
      'cityFrom': firstStepState['movingFromAddress']['cityAndState']['city'],
      'postalFrom': firstStepState['movingFromAddress']['searchFromPostalCode'],
      'streetAddressFrom': firstStepState['movingFromAddress']['streetAddress'],
      'cityStateTo': firstStepState['movingToAddress']['cityAndState'],
      'cityTo': firstStepState['movingToAddress']['cityAndState']['city'],
      'postalTo': firstStepState['movingToAddress']['searchToPostalCode'],
      'streetAddressTo': firstStepState['movingToAddress']['streetAddress'],
      'date': firstStepState['movingDate'],
      'directDistance': firstStepState['pickupToDelivery']['distance'],
      'longestDistance': firstStepState['longestDistance'],
      'pickupState': firstStepState['pickupState'],
      'deliveryState': firstStepState['deliveryState'],
      'baseToDelivery': firstStepState['baseToDelivery']['distance'],
      'baseToPickup': firstStepState['baseToPickup']['distance'],
      'travelDuration': firstStepState['travelDuration'],
      'floorFrom': firstStepState['movingFromFlights'].value,
      'floorTo':   firstStepState['movingToFlights'].value,
      'frontCf': 0,
      'packaging': "",
      'tempuraPedic': this.state.tempuraPedic.value,
      'tempuraPedicQty': this.state.tempuraPedic.qty,
      'rentBoxesQty': this.state.rentBoxes.qty,
      'rentBoxes': this.state.rentBoxes.value,
      'travelDurationBP' : firstStepState['travelDurationBP'],
      'travelDurationDB' : firstStepState['travelDurationDB'],
      'travelDurationPD' : firstStepState['travelDurationPD'],
      'moveTypeFrom' : firstStepState['movingFromElevator'].label,
      'moveTypeTo' : firstStepState['movingToElevator'].label,
      'packingHouseSize' : this.state.packingHouseSize.value,
      'walkUp' : this.state.walkUp.value,
      'addItemPrice' : 0,
      'storageOption' : this.state.storageOption.value,
      'referrence': {
        'name': "",
        'type': 0,
      },
    }

        fetch('/wp-json/qc/v1/calculate', {
      method: 'POST',
      headers: {
        'Accept': 'application/json; charset=UTF-8',
        'Content-Type': 'application/json; charset=UTF-8',
      },
      body: JSON.stringify({
        "user_input": JSON.stringify(userInput)
      })
    })
    .then(res => res.json())
    .then(
      (result) => {

        //Prepare output for state
        let moveDetails = JSON.parse(result);
        console.log(moveDetails);
        // Get all pricess
        let tempuraPedicPrice = JSON.parse(moveDetails.tempura_charge);
        let rentBoxesPrice = JSON.parse(moveDetails.rentBoxes_charge);

        this.setState({
          isLoaded: true,
          tempuraPedicPrice: tempuraPedicPrice,
          rentBoxesPrice: rentBoxesPrice
        });
      },

      (error) => {
        this.setState({
          isLoaded: true,
          error
        }, () => console.log(error));
      }
    );

  }

    /**FRONT END BETWEEN STEPS STYLE**/
  /*
   * Changing quantity of inventory element when input field is selected and typed.
   * @param  {[type]} event       general event
   * @param  {[type]} currentItem item that needs to be saved
   * @param  {[type]} room        location of the item
   * @return {[type]}             nothing
   */
  onQuantityChange ( event, currentItem, room ) {

    // Get all saved items from the state.
    let items = this.state.items;

    // Get or set the quantity to 0.
    let quantity = ( parseInt(event.target.value, 10) ) ? parseInt(event.target.value, 10) : 0;



    // If room is not set, set it up.
    if(!items[room]){
      items[room] = {
        name: room,
        elements: {}
      }
    }

    // Save item and call method for calculating total volume.
    items[room]['elements'][currentItem.name] = {
      name: currentItem.name,
      quantity: quantity,
      volume: currentItem.cf,
      theprice: parseInt(currentItem.price, 10)
    }

    this.setState({
      items: items
    }, this.calculateTotalVolume())
  }


  /**
   * Change quantity of a element on plus button click
   * @param  {[type]} currentItem [description]
   * @param  {[type]} room        [description]
   * @return {[type]}             [description]
   */
  onItemPlus (currentItem, room) {
    // Get all saved items from the state.
    let items = this.state.items;

    //Set quantity
    let quantity = 0;
    if( items[room] ){
      if(items[room]['elements'][currentItem.name]) {
        quantity = items[room]['elements'][currentItem.name]['quantity'];
      }
    }

    //Set room if not defiend
    if(!items[room]){
      items[room] = {
        name: room,
        elements: {}
      }
    }

    // Save item and call method for calculating total volume.
    quantity = quantity + 1;

    items[room]['elements'][currentItem.name] = {
      name: currentItem.name,
      quantity: quantity,
      volume: currentItem.cf,
      theprice: currentItem.price
    }
    this.setState({
      items: items
    }, this.calculateTotalVolume() )

  }


  /**
   * Change quantity of a element on minus button click
   * @param  {[type]} currentItem [description]
   * @param  {[type]} room        [description]
   * @return {[type]}             [description]
   */
  onItemMinus (currentItem, room) {
    // Get all saved items from the state.
    let items = this.state.items;

    // Set start quantity
    let quantity = 0;

    // Do the quantity change if room exists (it must exist if item quanity is higher than 0)
    if( items[room] ){
      if(items[room]['elements'][currentItem.name] && items[room]['elements'][currentItem.name]['quantity'] > 0) {
        quantity = items[room]['elements'][currentItem.name]['quantity'];
        quantity = quantity - 1;
        items[room]['elements'][currentItem.name] = {
          name: currentItem.name,
          quantity: quantity,
          volume: currentItem.cf,
          theprice: currentItem.price
        }

        // Save and call calculate method
        this.setState({
          items: items
        }, this.calculateTotalVolume() );
      }
    }
  }


  /**
   * Method for adding custom items
   * @return {[type]} [description]
   */
  addCustomItem() {

    // Get all values with refs attribute
    const name = this.refs.customItemName.value;
    const lenght = parseInt(this.refs.customItemLenght.value,10);
    const width =  parseInt(this.refs.customItemWidth.value,10);
    const height = parseInt(this.refs.customItemHeight.value,10);
    let quantity = parseInt(this.refs.customItemQuantity.value,10);


    // If all values are defined
    if ( name  && lenght && width && height && quantity ){

      // Get all items
      let items = this.state.items;
      // If there is no room 'custom items' create one
      let customItems = this.state.items['Custom Items'] || { name: 'Custom Items', elements: {}};

      // Set custom item index so we can use it when deliting custom items
      let customItemIndex = this.state.customItemIndex;
      customItemIndex = customItemIndex + 1;

      // Calculate custom items volume based on input fields
      let customItemCf =  Math.ceil(lenght *  width *  height / 1728);

      // Save custom item into a variable
      customItems['elements'][customItemIndex] = {
          'name' : name,
          'lenght' : lenght,
          'width' : width,
          'height' : height,
          'quantity' : quantity,
          'volume' : customItemCf,
          'theprice' : 0
      }

      // Set all items room 'Custom Items' from the variable
      items['Custom Items'] = customItems;

      // Save custom items and custom items index to state and calculate volume
      this.setState({
          items: items,
          customItemIndex: customItemIndex,
        }, this.calculateTotalVolume() );

      // Empty all input fields so visitor create a new custom item
      this.refs.customItemName.value = '';
      this.refs.customItemLenght.value = '';
      this.refs.customItemWidth.value = '';
      this.refs.customItemHeight.value = '';
      this.refs.customItemQuantity.value = '';

    }
    else {

      // If all input fields are not defined show error
      this.refs.customItemName.className= !name ? 'input-error' : '';
      this.refs.customItemLenght.className= !lenght ? 'input-error' : '';
      this.refs.customItemWidth.className= !width ? 'input-error' : '';
      this.refs.customItemHeight.className= !height ? 'input-error' : '';
      this.refs.customItemQuantity.className= !quantity ? 'input-error' : '';
    }
  }


  /**
   * Showing errors if custom item fields are deleted
   * @param  {[type]} event [description]
   * @return {[type]}       [description]
   */
  onCustomItemFieldChange (event) {
    event.target.className = !event.target.value ? 'input-error' : '';
  }


  /**
   * Removing custom when clicked on the remove button
   * @param  {[type]} itemToBeRemoved [description]
   * @return {[type]}                 [description]
   */
  removeCustomItem (itemToBeRemoved) {
    // Get all items from state
    let items = this.state.items;

    // Delete item that matches the index of clicked itemm, save to state and calculate volume
    delete items['Custom Items']['elements'][itemToBeRemoved];
    this.setState({
          items: items,
        }, this.calculateTotalVolume() );
  }


  /**
   * Calculate total volume based on all saved items
   * @return {[type]} [description]
   */
  calculateTotalVolume () {
    let totalVolume = 0;
    let addItemPrice = 0;

    // Loop through all rooms and get volume and quantity of all items and calculate the sum
    Object.keys(this.state.items).forEach( room =>
      Object.keys(this.state.items[room]['elements']).forEach( item => {
        totalVolume = totalVolume + this.state.items[room]['elements'][item].volume * this.state.items[room]['elements'][item].quantity;
        addItemPrice = addItemPrice + this.state.items[room]['elements'][item].theprice * this.state.items[room]['elements'][item].quantity;
      })
    );

    // Save total volume to State and hide volume eror message if there is any
    this.setState({
        totalVolume: totalVolume,
        volumeErrorMsg: 'hide-error-msg',
        addItemPrice : addItemPrice
      }, ()=> console.log(this.state, 'thisstate'));

  }


  /**
   * Method for validating and saving dropdown input field value
   * @param  {[type]} event input field that is changing
   * @return {[type]}       adding or removing error class
   */
  onInputFieldChange(event) {
    let { name, value } = event.target;

    // Set default validity indicator to false
    let isFieldValid = false;

    if(name === 'packingHouseSize'){
        this.setState({
        [name] : {
          'value' : value,
          'isFieldValid' : isFieldValid
        },
    });
    }

    else if(name === 'storageOption'){
        this.setState({
        [name] : {
          'value' : event.target.options[event.target.selectedIndex].value,
          'label' : event.target.options[event.target.selectedIndex].text,
          'checked' : true,
          'qty' : 0,
        },
    });
    }
    else{
        // Save input field to state
    this.setState({
        [name] : {
          'value' : event.target.options[event.target.selectedIndex].value,
          'label' : event.target.options[event.target.selectedIndex].text,
        }
    } );

    }


    // If there is value that means that option is selected and show/hide error based on that
    isFieldValid = value ? true : false;
    event.target.className = ( isFieldValid ? 'input-valid' : 'input-error' );
  }


/**
 * Checking all inputs and calling third step if ok
 * @param  {[type]} event button to be clicked
 * @return {[type]}       third step or error msg
 */
  handleNext (event) {

    event.preventDefault();

    // Checking that all user inputs are inserted
    if( this.state.totalVolume > 0 && this.state.packingOption.value &&  this.state.referrence.value && this.state.packingHouseSize.value ) {
        const calcFormAnchor = ( window.scrollY + document.getElementById('calcForm').getBoundingClientRect().top - 200);
        const activeStep = this.readTopState('activeStep');
        this.saveTopState({

          // Going to next step and saving all variables to state
          secondStepState: this.state,
          activeStep: activeStep + 1,
        }, ()=> window.scrollTo(0, calcFormAnchor) );

    }
    // Activating error class if some inputs are not defined
    else {

      // If there are not items, show error msg, if there are, just show dropdown errors
      if(this.state.totalVolume === 0) {
        this.setState({
        errorclass : 'input-error',
        volumeErrorMsg : 'show-error-msg'
        });
      }
      else {
        this.setState({
        errorclass : 'input-error',
        });
      }

    }
  }


addRentBoxes (operation, name) {

let quantity, value, checked;
switch(name) {
  case "tempuraPedic":
      quantity = this.state.tempuraPedic.qty ? this.state.tempuraPedic.qty : 0;
      value = this.state.tempuraPedic.value;
      checked = this.state.tempuraPedic.checked;
    break;
  case "rentBoxes":
      quantity = this.state.rentBoxes.qty ? this.state.rentBoxes.qty : 0;
      value = this.state.rentBoxes.value;
      checked = this.state.rentBoxes.checked;
    break;
}



   if(operation === "add" ){
      quantity += 1;
   }

   if(operation === "subtract" && quantity > 0){
      quantity -= 1;
   }

    this.setState({
        [name] : {
          'value' : value,
          'checked' : checked,
          'qty': quantity
        },
    }, ()=>{

      console.log(this.state , "this.state");
    });

  }

  handleCheckboxChange (event) {

    let { name, value } = event.target;

    let tempura = "No";


    if(event.target.checked === true){
      tempura = "Yes";
    }


      // Saving to state
    this.setState({
        [name] : {
          'value' : tempura,
          'checked' : event.target.checked,
          'qty': Number(event.currentTarget.dataset.qty)
        },
    }, ()=> console.log(this.state));

  }

  /**
   * Going on the previous step
   * @param  {[type]} event [description]
   * @return {[type]}       [description]
   */
  handleBack (event) {

    const calcFormAnchor = ( window.scrollY + document.getElementById('calcForm').getBoundingClientRect().top - 200);

    event.preventDefault();

    const activeStep = this.readTopState('activeStep');
    this.saveTopState({
      activeStep: activeStep - 1,
      secondStepState: this.state,
    }, ()=> window.scrollTo(0, calcFormAnchor) );


  };

  handleToggle(event) {
    event.preventDefault();

    /**hide all elements if any are open**/
    let hideAll = document.querySelectorAll(".hideRooms");
    let rotateAllBack = document.querySelectorAll("h3[data-togglerooms]");
    let hideThisRoom = event.currentTarget.dataset.togglerooms;
    let hideThisElement = document.getElementById(hideThisRoom);


    hideAll.forEach(el => {
      if(hideThisElement !== el){
        el.classList.add('hideElement');
      }
    });


    rotateAllBack.forEach(el => {
      if(event.target !== el){
        el.classList.remove('rotateBeforeEl');
      }
    });
    /**toggle class**/

    hideThisElement.classList.toggle('hideElement');
     event.target.classList.toggle('rotateBeforeEl');

    /**change direction of arrows**/

    event.target.scrollIntoView({behavior: "smooth", block: "start", inline: "start"});
    // window.scrollBy(0, -200);

  }
//style={{display: this.state.isToggle ? 'block': 'none'}}
  render() {
    // let allItems = {};
  	return (
	  	<div className="qc-second-step">
       {Object.keys(secondStepConstanst['rooms']).map( room =>
        <div key={secondStepConstanst['rooms'][room]['name']} className="qc-room">
          <h3 onClick={this.handleToggle} data-togglerooms={secondStepConstanst['rooms'][room]['name']}>{ secondStepConstanst['rooms'][room]['name'] }</h3>
          <div id={secondStepConstanst['rooms'][room]['name']} className="hideRooms hideElement">
            {Object.keys(secondStepConstanst['rooms'][room]['category']).map( category =>
              <div key={secondStepConstanst['rooms'][room]['category'][category]['name']} className="no-margin qc-room-category">
                <h4>{ secondStepConstanst['rooms'][room]['category'][category]['name'] }</h4>
                          <div className="inner-room">
                {Object.keys(secondStepConstanst['rooms'][room]['category'][category]['items']).map( item => {

                  // Looping through rooms, categories and items get values for every element and store
                  let currentRoom = secondStepConstanst['rooms'][room]['name'];
                  let currentItem = secondStepConstanst['rooms'][room]['category'][category]['items'][item];
                  let imgUrl = '/wp-content/plugins/quote-calculator-r/assets/img/' + currentItem['img'];

                  // Set quantity to defaul 0, and then pick value from state it there is any
                  let currentItemQuantity = 0;
                  if(this.state.items[currentRoom]){
                    if(this.state.items[currentRoom]['elements'][currentItem.name]){
                        currentItemQuantity = this.state.items[currentRoom]['elements'][currentItem.name]['quantity']
                    }
                  }

                  return(

                  <div key={secondStepConstanst['rooms'][room]['category'][category]['items'][item]['name']}className="qc-item">
                    <div className="qc-item-inner">
                      <div className={ currentItemQuantity > 0 ? 'qc-active-item qc-item-container' : 'qc-item-container'}>
                        <div className="qc-item-title noppading">
                          <p>{ currentItem['name'] }</p>
                        </div>
                        <div className="qc-inner-item-container">
                          <div className="qc-item-picture noppading">
                            <img src={imgUrl} alt="item-icon"/>
                          </div>

                            <div className="qc-item-controls noppading nomargin">
                              <button onClick={() => this.onItemPlus(currentItem, currentRoom)} type="button">+</button>
                              <button onClick={() => this.onItemMinus(currentItem, currentRoom)} type="button">-</button>
                            </div>
                            <div className="qc-item-quantity noppading nomargin">
                              <input onChange={(event) => this.onQuantityChange(event, currentItem, currentRoom)} value={ currentItemQuantity } type="number" />
                            </div>

                        </div>
                      </div>
                    </div>
                  </div>
                );}

                )}
              </div>
                        </div>

          )}
        </div>
 </div>
      )}

  <div className="custom-items">
            <h3 onClick={this.handleToggle} data-togglerooms="custom-items-toggle" className="qc-room__title ng-binding">Custom Items</h3>
            <div className="hideElement" id="custom-items-toggle">
                <h4>Add your custom items</h4>
                <div className="custom-item-holder">
                    <div>
                        <input type="text" ref="customItemName" placeholder="Item Name" onChange={this.onCustomItemFieldChange} />
                    </div>
                    <div>
                        <input type="number" min="0" ref="customItemLenght" placeholder="Length (inches)" onChange={this.onCustomItemFieldChange} />
                    </div>
                    <div>
                        <input type="number" min="0" ref="customItemWidth" placeholder="Width (inches)" onChange={this.onCustomItemFieldChange} />
                    </div>
                    <div>
                        <input type="number" min="0" ref="customItemHeight" placeholder="Height (inches)" onChange={this.onCustomItemFieldChange} />
                    </div>
                    <div>
                        <input type="number" min="0" ref="customItemQuantity" placeholder="Quantity" onChange={this.onCustomItemFieldChange} />
                    </div>
                    <div>
                        <input type="button" value="Add" id="custom-button" onClick={()=> this.addCustomItem()} />
                    </div>
                </div>
            </div>
        </div>
        { this.state.items['Custom Items'] ? Object.keys(this.state.items['Custom Items']['elements']).map( customItem =>
        <div key={this.state.items['Custom Items']['elements'][customItem].name} className="custom-item-generated">
            <div>
                <input type="text" value={this.state.items['Custom Items']['elements'][customItem].name} disabled />
            </div>
            <div>
                <input type="text" value={'Quantity: ' + this.state.items['Custom Items']['elements'][customItem].quantity} disabled />
            </div>
            <div>
                <input type="text" value={'Volume: ' + this.state.items['Custom Items']['elements'][customItem].volume + 'CF' } disabled />
            </div>
            <div className="steps-navigation">
                <input type="button" className="btn" name="custom-button-remove" value="Remove" onClick={()=> this.removeCustomItem(customItem)} />
            </div>
        </div>
        ) : ''}
        <div className="special-notice">
            <h3>Please keep in mind the following: </h3>
            <ul>
                <li>
                    We cannot disconnect or reconnect water or gas lines to any appliance.
                </li>
                <li>
                    We will not move FSTV unless they are in the original carton or a TV kit we can supply.
                </li>
                <li>
                    We cannot move a hot tub and we cannot move a gun safe over 1,000 lbs.
                </li>
            </ul>
        </div>
        <div className="packing-wrapper">
            <h3 className="qc-room__title">Additional Options</h3>
            <div className="qc-add-option">
                <div className="checkbox-wrapper">
                    <input type="checkbox" id="tempuraPedic" checked={this.state.tempuraPedic.checked} data-qty={this.state.tempuraPedic.qty} onChange={this.handleCheckboxChange} name="tempuraPedic" />
                    <label htmlFor="tempuraPedic">
                        <span>Would you like Mattress Box Service? (${this.state.tempuraPedicPrice} per box)</span>
                    </label>
                     <div className={ (this.state.tempuraPedic.checked===false) ? "hidden" : "addRentBoxes" }>
                        <p className="totalNumber">How many boxes would you like? <span>{this.state.tempuraPedic.qty}</span></p>
                        <div className="qc-item-controls">
                            <button onClick={()=> this.addRentBoxes("add","tempuraPedic")} type="button">+</button>
                            <button onClick={()=> this.addRentBoxes("subtract","tempuraPedic")} type="button">-</button>
                        </div>
                    </div>
                </div>





                <div className="checkbox-wrapper">
                    <input type="checkbox" id="rentBoxes" checked={this.state.rentBoxes.checked} data-qty={this.state.rentBoxes.qty} onChange={this.handleCheckboxChange} name="rentBoxes" />
                    <label htmlFor="rentBoxes">
                        <span>Would you like to rent Wardrobe Boxes? (${this.state.rentBoxesPrice} per box)</span>
                    </label>
                    <div className={ (this.state.rentBoxes.checked===false) ? "hidden" : "addRentBoxes" }>
                        <p className="totalNumber">How many boxes would you like? <span>{this.state.rentBoxes.qty}</span></p>
                        <div className="qc-item-controls">
                            <button name="rentBoxes" onClick={()=> this.addRentBoxes("add","rentBoxes")} type="button">+</button>
                            <button name="rentBoxes" onClick={()=> this.addRentBoxes("subtract","rentBoxes")} type="button">-</button>
                        </div>
                    </div>
                </div>

                 <div className="checkbox-wrapper">
                    <input type="checkbox" id="storageOption" checked={this.state.storageOption.checked} data-qty="0" onChange={this.handleCheckboxChange} name="storageOption" />
                    <label htmlFor="storageOption">
                        <span>Are you interested in our Storage Services?</span>
                    </label>
                     <div className={ (this.state.storageOption.checked===false) ? "hidden" : "addRentBoxes storageOption" }>
                          <select name="storageOption" type="select" defaultValue={this.state.storageOption.value || 0}  onChange={this.onInputFieldChange}>
                              <option disabled value="0">Duration</option>
                              {secondStepConstants.storageOption.map(option =>
                              <option name="storageOption" key={option.value} value={option.label}>{option.label}</option>
                              )};
                          </select>
                          <p className={ (this.state.storageOption.label !== "Non-Temp") ? "hidden" : "md-notification" }>The estimate generated by this calculator will not reflect Non-Temp Storage, however we can account for this after a brief discussion with you once you have received your estimate.</p>
                    </div>
                </div>

                 <div className="checkbox-wrapper">
                    <input type="checkbox" id="walkUp" checked={this.state.walkUp.checked} data-qty="0" onChange={this.handleCheckboxChange} name="walkUp" />
                    <label htmlFor="walkUp">
                        <span>Long walk or access issues (such as low trees, dirt roads, steep driveways)</span>
                    </label>
                     <div className={ (this.state.walkUp.checked===false) ? "hidden" : "addRentBoxes" }>
                        <p className="md-notification">The estimate generated by this calculator will not reflect these potential issue(s), however we can account for this after a brief discussion with you once you have received your estimate.</p>
                    </div>
                </div>



            </div>
        </div>
        <div className="qc-packing">
            <div>
                <select name="packingOption" type="select" defaultValue={this.state.packingOption.value || 0} className={ !this.state.packingOption.label ? this.state.errorclass : "untouched" } onChange={this.onInputFieldChange}>
                    <option disabled value="0">Select Packing Option</option>
                    {Object.keys(secondStepConstanst['packaging']).map( option =>
                    <option name="packingOption" key={secondStepConstanst['packaging'][option]['type']} value={secondStepConstanst['packaging'][option]['type']}>{secondStepConstanst['packaging'][option]['name']}</option>
                    )};
                </select>
            </div>

            <div>
                <input type="number" min="0" defaultValue={this.state.packingHouseSize.value} className={ !this.state.packingHouseSize.value ? this.state.errorclass : "untouched" } name="packingHouseSize" id="packingHouseSize" placeholder="Approximate Square Footage" onChange={this.onInputFieldChange} />
            </div>


            <div>
                <select name="referrence" type="select" defaultValue={this.state.referrence.value || 0} className={ !this.state.referrence.label ? this.state.errorclass : "untouched" } onChange={this.onInputFieldChange}>
                    <option disabled value="0">How Did You Hear About us</option>
                    {Object.keys(secondStepConstanst['referrence']).map( option =>
                    <option name="referrence" key={secondStepConstanst['referrence'][option]['type']} value={secondStepConstanst['referrence'][option]['type']}>{secondStepConstanst['referrence'][option]['name']}</option>
                    )};
                </select>
            </div>
        </div>
        <span className={ this.state.volumeErrorMsg }>Please select furniture</span>
        <div className="steps-navigation btn-x-2">
            <div className="vm-prev-btn">
                <Button type="submit" onClick={this.handleBack}>Previous</Button>
            </div>
            <div className="sec-next-btn">
                <Button type="submit" onClick={this.handleNext}>Next</Button>
            </div>
        </div>
        </div>
  	);
	}
}

export default SecondStep;



// WEBPACK FOOTER //
// ./src/steps/SecondStep.js